import React from 'react';
import { ArrowUpRight } from 'lucide-react';

/**
 * Autorenangaben, zentral gepflegt für Blog, Berufsseiten und "Über uns".
 * Eine überprüfbare Person hinter dem Text ist ein Vertrauenssignal,
 * für Leser wie für Suchmaschinen.
 */
export const AUTOREN = {
  kamran: {
    name: 'Kamran Essam',
    rolle: 'Gründer und Geschäftsführer',
    linkedin: 'https://www.linkedin.com/in/kamranessam/',
    foto: '/images/team-kamran-essam.avif',
    portrait: '/images/team-kamran-essam-portrait.avif',
    kurzbio:
      'Gründer und Geschäftsführer von djiiga. Studium der Physikalischen Ingenieurwissenschaft an der TU Berlin, seit 2009 im IT-Recruiting in Berlin, seit 2013 mit djiiga.',
    bio:
      'Studium der Physikalischen Ingenieurwissenschaft an der TU Berlin, Einstieg ins Recruiting 2009 bei Robert Half Technology in Berlin. Seit über 15 Jahren besetzt er Fach- und Führungspositionen, mit Schwerpunkt auf IT-Spezialisten, Ingenieuren und Executive Search. Seit 2013 führt er djiiga gemeinsam mit Siamak Mohtachemi.',
    sprachen: 'Deutsch, Englisch, Persisch',
  },
  siamak: {
    name: 'Siamak Mohtachemi',
    rolle: 'Gründer und Geschäftsführer',
    linkedin: 'https://www.linkedin.com/in/siamak-mohtachemi-32a2326/',
    foto: '/images/team-siamak-mohtachemi.avif',
    portrait: '/images/team-siamak-mohtachemi-portrait.avif',
    kurzbio:
      'Gründer und Geschäftsführer von djiiga. Hat bei Robert Half Technology den IT-Bereich in Berlin, Hamburg und München mit aufgebaut und besetzt seit 2013 mit djiiga IT- und Führungspositionen.',
    bio:
      'MBA in International Management an der Freien Universität Berlin. Bei Robert Half Technology baute er von 2007 bis 2013 als Manager den IT-Bereich in Berlin, Hamburg und München mit auf. Seit 2013 arbeitet er mit djiiga als Headhunter und Executive-Search-Berater für IT, Produkt und Technologie-Führungskräfte, auch als Interim Recruiter in Unternehmen.',
    sprachen: 'Deutsch, Englisch, Persisch, Spanisch',
  },
} as const;

export type AutorKey = keyof typeof AUTOREN;

/** Autorenleiste am Ende eines Blogbeitrags */
const AuthorBio: React.FC<{ autor: AutorKey }> = ({ autor }) => {
  const a = AUTOREN[autor];
  return (
    <div className="author-bar">
      <span className="flex items-center gap-4">
        <img src={a.portrait} alt="" width={56} height={56} loading="lazy" decoding="async"
             className="size-14 shrink-0 rounded-full object-cover ring-2 ring-primary/30" />
        <span className="block">
          <span className="block text-xs font-mono uppercase tracking-[.14em] text-muted">Autor</span>
          <span className="block font-semibold text-white">{a.name}</span>
          <span className="block text-sm text-muted">{a.rolle} von djiiga</span>
        </span>
      </span>
      <a className="author-bar__link" href={a.linkedin} target="_blank" rel="noopener noreferrer me">
        LinkedIn-Profil <ArrowUpRight className="size-3.5" aria-hidden="true" />
      </a>
    </div>
  );
};
export default AuthorBio;
